import { ICreatePixPendencyPaymentDTO } from 'modules/customer/domain/dtos';
import { IContractPaymentsRepository } from 'modules/customer/domain/repositories';
import { UseCaseError } from 'shared/domain/errors';

export class CreatePixPendencyPaymentUseCase {
  constructor(
    private contractPaymentsRepository: IContractPaymentsRepository,
  ) {}

  public async execute({ process }: ICreatePixPendencyPaymentDTO) {
    const data = await this.contractPaymentsRepository.create({
      method: 'PIX',
      process,
    });

    if (!data.pix) throw new UseCaseError('Could not generate PIX');

    return data.pix;
  }
}
